/**
 * Created by mazedul.islam on 09-Oct-18.
 */
export const TransactionFeatures = {
  CRTransactionSettings      : 'CR-TransactionSettings',
  CRTransactionTopic   : 'CR-Transaction-Topic',
  CRTransactionTopicEdit: 'CR-Transaction-TopicEdit',
  CRTransactionAdd: 'CR-Transaction-Add',
  CRTransactionDelete: 'CR-Transaction-Delete',
  CRTransactionImport: 'CR-Transaction-Import'
};


